import { Injectable } from '@angular/core';
import { EventDefinition, NotificableEvent } from '../../shared/interfaces/event.interfaces';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FrontEventService {

  filterNotificableEvents(
    eventDefinitions: EventDefinition[] | undefined
  ): Observable<NotificableEvent[]> {
    const notificableEvents: NotificableEvent[] = (eventDefinitions ?? [])
      .filter(e => e.notificable)
      .map(e => ({
        id: e.id,
        name: e.name,
        notification: e.notification,
        tone: e.notification_tone
      }));

    return of(notificableEvents);
  }

}
